import { Injectable } from "@angular/core";
import { SERVER_API_URL } from "../app.constants";
import { HttpClient, HttpResponse } from "@angular/common/http";
import { Observable } from "rxjs";
import { Moment } from "moment";
import * as dataCore from "../core/datacore";
import moment = require("moment");
import { map } from "rxjs/operators";

@Injectable()
export class ActivityAdjustmentService {
    private resourceUrl = SERVER_API_URL + 'api/activity-adjustments';

    constructor(
        private http: HttpClient) {
    }

    getActivityAdjustment(id: number): Observable<HttpResponse<ActivityAdjustmentGet>> {
        return this.http
            .get<ActivityAdjustmentGetWithDayAsString>(`${this.resourceUrl}`, { observe: 'response', params: { 'id': `${id}` } })
            .pipe(map(res => res.clone({ body: this.getAdjustmentWithDayAsMoment(res.body) })));
    }

    getActivityAdjustments(fromDate: Moment, toDate: Moment): Observable<HttpResponse<ActivityAdjustmentGet[]>> {
        const fromDateString = dataCore.getStartOfDay(moment(fromDate)).toISOString();
        const toDateString = dataCore.getStartOfDay(moment(toDate)).toISOString();
        return this.http
            .get<ActivityAdjustmentGetWithDayAsString[]>(`${this.resourceUrl}`, { observe: 'response', params: { 'fromDate': fromDateString, 'toDate': toDateString } })
            .pipe(map(res => res.clone({ body: res.body.map(adjustment => this.getAdjustmentWithDayAsMoment(adjustment)) })));
    }

    createActivityAdjustment(adjustment: ActivityAdjustmentPost): Observable<HttpResponse<boolean>> {
        return this.http
            .post<boolean>(`${this.resourceUrl}`, this.withStartOfDay(adjustment), { observe: 'response' });
    }

    updateActivityAdjustment(adjustment: ActivityAdjustmentPut): Observable<HttpResponse<boolean>> {
        return this.http
            .put<boolean>(`${this.resourceUrl}`, this.withStartOfDay(adjustment), { observe: 'response' });
    }

    deleteActivityAdjustment(id: number): Observable<HttpResponse<boolean>> {
        return this.http
            .delete<boolean>(`${this.resourceUrl}`, { observe: 'response', params: { 'id': `${id}` } });
    }

    private getAdjustmentWithDayAsMoment(adjustment: ActivityAdjustmentGetWithDayAsString): ActivityAdjustmentGet {
        return { ...adjustment, Day: moment(adjustment.Day) };
    }

    private withStartOfDay<T extends ActivityAdjustmentPost>(adjustment: T): T {
        return { ...adjustment, Day: dataCore.getMomentStartOfDay(moment(adjustment.Day)) };
    }
}

export interface ActivityAdjustmentGet extends ActivityAdjustmentGetBase {
    Day: Moment;
}

interface ActivityAdjustmentGetWithDayAsString extends ActivityAdjustmentGetBase {
    Day: string;
}

interface ActivityAdjustmentGetBase extends ActivityAdjustmentBase {
    Id: number;
    PersonName: string;
    PersonSortTag: string;
    WorkplaceName: string;
    WorkplaceSortTag: string;
}

interface ActivityAdjustmentPut extends ActivityAdjustmentPost {
    Id: number;
}

interface ActivityAdjustmentPost extends ActivityAdjustmentBase {
    Day: Moment;
}

interface ActivityAdjustmentBase {
    NumberOfDays: number;
    PersonId: number;
    WorkplaceId: number;
    Comment: string;
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/services/activity-adjustment.service.ts